// extracted by mini-css-extract-plugin
export var button = "_ck-2";
export var iconWrapper = "_ck-0";
export var investigatingIcon = "_ck-1";